<template>
  <div class="flex no-wrap items-center" style="margin-left: -3px !important;">
    <div class="flex-zero m-r-xs">
      <label data-test="stage-1-rotting-flag" class="check-switch">
        <input :disabled="disabled" type="checkbox" v-model="model" v-on:input="$emit('input', $event.target.checked)">
        <div class="check-switch-toggle"></div>
      </label>
    </div>
    <span class="col-grow-1 font-12 sl-checkbox-confim" v-if="value">Sim</span>
    <span class="col-grow-1 font-12 sl-checkbox-confim" v-else>Não</span>
  </div>
</template>

<script>
export default {
  name: "SlCheckbox",
  props: {
    value: {
      required: true
    },
    yesVal: {
      default: 'Sim'
    },
    noVal: {
      default: 'Não'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value (v) {
      this.$nextTick(() => {
        if (this.model !== v) {
          this.model = v
        }
      })
    }
  },
  data () {
    return {
      model: this.value
    }
  }
}
</script>
